import React from 'react';

export default function Loader({ className }: { className?: string }) {
  return (
    <div
      className={`${className} flex space-x-2 p-5 rounded-full justify-center items-center`}
    >
      <div
        className='bg-turquoise-700 p-2 w-4 h-4 rounded-full animate-bounce'
        style={{ animationDelay: '0.1s' }}
      ></div>
      <div
        className='bg-turquoise-500 p-2 w-4 h-4 rounded-full animate-bounce'
        style={{ animationDelay: '0.2s' }}
      ></div>
      <div
        className='bg-turquoise-300 p-2 w-4 h-4 rounded-full animate-bounce'
        style={{ animationDelay: '0.3s' }}
      ></div>
    </div>
  );
}
